/**
 * Usonian CSS > Settings > Color
 */

// Brand colors
export const teal = '#08bfb0';
export const tealLight = '#def3f2';
export const transparent = 'rgba(0, 0, 0, 0)';
export const brandBlue = '#5b8edc';

// Neutrals
export const gainsboro = '#DDDDDD';
export const silver = '#C4CDD5';
export const grayLightest = '#F5F8FA';
export const grayLighter = '#E0E0E0';
export const grayLight = '#979797';
export const grayLight2 = '#D8D8D8';
export const gray = '#4a4a4a';
export const grayDark = '#637381';
export const grayBlue = '#8990b0';

// Colors
export const greenLight = '#62C514';
export const green = '#3ed411';
export const greenDark = '#388E3C';

export const blueLight = '#4f95ff';
export const blue = brandBlue;
export const blueDark = '#2e73db';
export const blueDarker = '#2f6fed';

export const red = '#ff4d4f';
export const redLightest = '#ff3d40';
export const yellow = '#F57C00';
export const orange = '#f7b500';

export const danger = red;
export const warning = yellow;
export const success = teal;
export const disabled = '#c9c9c9';

export const brown = '#594A42';
export const brownLight = '#F3F0EB';
export const white = '#FFFFFF';
export const background = '#f5f8fa';
export const purple = '#5E6BC5';
export const black = '#212B36';

export const whiteSmoke = '#FAFBFC';
// Base colors
export const baseColorAccent = brandBlue;
export const baseColorText = 'black';
export const baseColorWhite = '#f7f7f7';
export const mainColor = '#594A42';
export const midnightGrey = '#212121';
